import React from 'react';
import s from './select.module.css';
var SelectOptionEmpty = function SelectOptionEmpty(_ref) {
  var _ref$emptyText = _ref.emptyText,
    emptyText = _ref$emptyText === void 0 ? 'Ничего не найдено' : _ref$emptyText;
  return React.createElement("div", {
    className: s.emptyOption
  }, emptyText);
};
export default SelectOptionEmpty;